<template>
    <div class="Fail_report">
        <Navbar/>
        <v-container class="grey lighten-5">
            <Transfail/>
        </v-container>
    </div>
</template>

<script>
    import Navbar from '../components/Navbar';
    import Transfail from '../components/Failreporthist';
    export default{
        name: 'Fail_report',
        components:{
            Navbar,
            Transfail
        }
    }
</script>